import React, { useEffect, useState } from 'react';
import { Flex, Flexed, Scroll, currency } from '../../utilities/Shared';
import { sortdate, sortit, sortnum } from '../../utilities/Sort';
import axios from 'axios';
import { NavLink, useNavigate } from 'react-router-dom';
import Collapse from '../../utilities/Collapse';

const Estimatedaily = ({ salesreps, setSalesreps, jobstoday }) => {
  const [quotes, setQuotes] = useState([]);
  const [order, setOrder] = useState("ASC");
  const [newlist, setNewlist] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const nav = useNavigate();

  // Calculate week days
  const dt = new Date();
  const day = dt.getDay();
  const diff = dt.getDate() - day + (day === 0 ? -6 : 1) - 1;
  const start = new Date(dt.setDate(diff));
//const start = new Date('2025-11-16T00:00:00')

  const ismonday = new Date(start.setDate(start.getDate() + 1));
  const istuesday = new Date(start.setDate(ismonday.getDate() + 1));
  const iswednesday = new Date(start.setDate(istuesday.getDate() + 1));
  const isthursday = new Date(start.setDate(iswednesday.getDate() + 1));
  const isfriday = new Date(start.setDate(isthursday.getDate() + 1));

  useEffect(() => {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    };

    const getjobs = async () => {
      try {
        setLoading(true);
        const res = await axios.get('https://highgroundsoftware.com/dash/dashboard/php/getallquotesfordaily.php', config); // Changed to GET
        console.log('Quotes API response:', res.data);
        if (Array.isArray(res.data)) {
          setQuotes(res.data);
        } else {
          throw new Error('Invalid response format from API');
        }
      } catch (error) {
        console.error('Error fetching quotes:', error);
        setError('Failed to load quotes. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    getjobs();
  }, []);

  useEffect(() => {
    if (!salesreps?.length || !quotes?.length) {
      console.log('Missing data: salesreps or quotes empty', { salesreps, quotes });
      return;
    }

    const t = salesreps.map(rep => ({
      name: `${rep.firstName} ${rep.lastName?.charAt(0) || ''}`,
      monday: monday(rep),
      tuesday: tuesday(rep),
      wednesday: wednesday(rep),
      thursday: thursday(rep),
      friday: friday(rep),
      id: rep.empId,
    }));

    setNewlist(t);
  }, [quotes, salesreps]);

  const monday = (rep) => {
    return quotes.filter(quote => 
      quote.salesrep === rep.empId && 
      new Date(quote.entered).toLocaleDateString() === ismonday.toLocaleDateString()
    );
  };

  const tuesday = (rep) => {
    return quotes.filter(quote => 
      quote.salesrep === rep.empId && 
      new Date(quote.entered).toLocaleDateString() === istuesday.toLocaleDateString()
    );
  };

  const wednesday = (rep) => {
    return quotes.filter(quote => 
      quote.salesrep === rep.empId && 
      new Date(quote.entered).toLocaleDateString() === iswednesday.toLocaleDateString()
    );
  };

  const thursday = (rep) => {
    return quotes.filter(quote => 
      quote.salesrep === rep.empId && 
      new Date(quote.entered).toLocaleDateString() === isthursday.toLocaleDateString()
    );
  };

  const friday = (rep) => {
    return quotes.filter(quote => 
      quote.salesrep === rep.empId && 
      new Date(quote.entered).toLocaleDateString() === isfriday.toLocaleDateString()
    );
  };

  return (
    <>
      <Flexed margin="30px 0px 0px 0px" bgColor="#8398AB" color="white" padding="5px 0px">
        <Flex fontSize="calc(1.1rem + .4vw)">Daily Estimates</Flex>
      </Flexed>
      <Flexed>
        <Flex fontSize="14px" flex="1.5" onClick={() => sortit('name', order, newlist, setNewlist, setOrder)}>Sales Rep</Flex>
        <Flex fontSize="14px" onClick={() => sortnum('monday', order, newlist, setNewlist, setOrder)}>Monday</Flex>
        <Flex fontSize="14px" onClick={() => sortnum('tuesday', order, newlist, setNewlist, setOrder)}>Tuesday</Flex>
        <Flex fontSize="14px" onClick={() => sortnum('wednesday', order, newlist, setNewlist, setOrder)}>Wednesday</Flex>
        <Flex fontSize="14px" onClick={() => sortnum('thursday', order, newlist, setNewlist, setOrder)}>Thursday</Flex>
        <Flex fontSize="14px" onClick={() => sortnum('friday', order, newlist, setNewlist, setOrder)}>Friday</Flex>
      </Flexed>
      {loading ? (
        <p style={{ padding: "20px 0px", fontSize: "var(--headerLarge)", color: "rgb(255,0,0,.6)" }}>LOADING...</p>
      ) : error ? (
        <p style={{ padding: "20px 0px", fontSize: "var(--headerLarge)", color: "rgb(255,0,0,.6)" }}>{error}</p>
      ) : newlist.length > 0 ? (
        <>
          {newlist.map(item => (
            <Collapse
              key={item.id}
              margin="0"
              title={
                <Flexed style={{ borderBottom: "1px solid black", padding: "4px", background: "white" }} className="hand">
                  <Flex fontSize="14px" flex="1.5">{item.name}</Flex>
                  <Flex fontSize="14px">{item.monday?.length || 0}</Flex>
                  <Flex fontSize="14px">{item.tuesday?.length || 0}</Flex>
                  <Flex fontSize="14px">{item.wednesday?.length || 0}</Flex>
                  <Flex fontSize="14px">{item.thursday?.length || 0}</Flex>
                  <Flex fontSize="14px">{item.friday?.length || 0}</Flex>
                </Flexed>
              }
            >
              <Flexed className="hand" padding="5px" color="black">
                <Flex fontSize="14px" flex="1.5" padding="4px 0px"></Flex>
                <Flex fontSize="12px" padding="4px 0px">
                  {item.monday?.map(ite => (
                    <span key={ite.quote}>
                      <a href={`https://highgroundsoftware.com/dash/dashboard/?des=15002&q=${ite.quote}`}>{ite.quote}</a>
                      <br />
                    </span>
                  ))}
                </Flex>
                <Flex fontSize="12px" padding="4px 0px">
                  {item.tuesday?.map(ite => (
                    <span key={ite.quote}>
                      <a href={`https://highgroundsoftware.com/dash/dashboard/?des=15002&q=${ite.quote}`}>{ite.quote}</a>
                      <br />
                    </span>
                  ))}
                </Flex>
                <Flex fontSize="12px" padding="4px 0px">
                  {item.wednesday?.map(ite => (
                    <span key={ite.quote}>
                      <a href={`https://highgroundsoftware.com/dash/dashboard/?des=15002&q=${ite.quote}`}>{ite.quote}</a>
                      <br />
                    </span>
                  ))}
                </Flex>
                <Flex fontSize="12px" padding="4px 0px">
                  {item.thursday?.map(ite => (
                    <span key={ite.quote}>
                      <a href={`https://highgroundsoftware.com/dash/dashboard/?des=15002&q=${ite.quote}`}>{ite.quote}</a>
                      <br />
                    </span>
                  ))}
                </Flex>
                <Flex fontSize="12px" padding="4px 0px">
                  {item.friday?.map(ite => (
                    <span key={ite.quote}>
                      <a href={`https://highgroundsoftware.com/dash/dashboard/?des=15002&q=${ite.quote}`}>{ite.quote}</a>
                      <br />
                    </span>
                  ))}
                </Flex>
              </Flexed>
            </Collapse>
          ))}
        </>
      ) : (
        <p style={{ padding: "20px 0px", fontSize: "var(--headerLarge)", color: "rgb(255,0,0,.6)" }}>
          No data available
        </p>
      )}
      <Flexed className="normalrow hand" bgColor="#8398AB" color="white" padding="5px 0px">
        <Flex fontSize="12px" flex="1.5"></Flex>
        <Flex fontSize="12px"></Flex>
        <Flex fontSize="12px"></Flex>
        <Flex fontSize="12px"></Flex>
        <Flex fontSize="12px"></Flex>
        <Flex fontSize="12px"></Flex>
      </Flexed>
    </>
  );
};

export default Estimatedaily;